<script setup>
import { router, Head, useForm } from '@inertiajs/vue3';
import JetAuthenticationCard from '@/Jetstream/AuthenticationCard.vue';
import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo.vue';
import JetButton from '@/Jetstream/Button.vue';
import JetInput from '@/Jetstream/Input.vue';
import JetLabel from '@/Jetstream/Label.vue';
import JetValidationErrors from '@/Jetstream/ValidationErrors.vue';
import JetApplicationHeader from '@/Jetstream/ApplicationHeader.vue';
import JetApplicationFooter from '@/Jetstream/ApplicationFooter.vue';
import JetWelcomePanel from '@/Jetstream/WelcomePanel.vue';
import AppTheming from '@/Jetstream/AppTheming.vue';

const props = defineProps({
    email: String,
    token: String,
});

const programme = router.page.props.ziggy.programme;
const organisation = router.page.props.ziggy.organisation;

let urlNamePrefix = '';
if (organisation) {
    urlNamePrefix = "gi.";
} else if (!organisation && !programme) {
    urlNamePrefix = "platform.";
}

const form = useForm({
    token: props.token,
    email: props.email,
    password: '',
    password_confirmation: '',
});

const submit = () => {
    form.post(route(urlNamePrefix+'password.update'), {
        onFinish: () => form.reset('password', 'password_confirmation'),
    });
};
</script>

<template>
    <AppTheming />

    <Head title="Reset Password" />

    <JetApplicationHeader />

    <div id="content-wrapper">

        <div id="main-content" class="container mx-auto flex flex-col md:flex-row justify-between w-full pt-5 pb-5">

            <div id="col-intro" class="md:w-2/3 md:pr-10 lg:pr-40">
                <JetWelcomePanel />
            </div>
            <div id="col-form" class="md:w-1/3">

                <div class="card sos-programme-form-card p-10 rounded-2xl mt-10">

                    <h2 class="font-bold mb-5">{{ $t('application.auth.reset_password') }}</h2>

                    <JetValidationErrors class="mb-4" />

                    <form @submit.prevent="submit">
                        <div>
                            <JetLabel for="email" :value="$t('application.auth.email')" />
                            <JetInput
                                id="email"
                                v-model="form.email"
                                type="email"
                                class="mt-1 block w-full"
                                required
                                autofocus
                            />
                        </div>

                        <div class="mt-4">
                            <JetLabel for="password" :value="$t('application.general.password')" />
                            <JetInput
                                id="password"
                                v-model="form.password"
                                type="password"
                                class="mt-1 block w-full"
                                required
                                autocomplete="new-password"
                            />
                        </div>

                        <div class="mt-4">
                            <JetLabel for="password_confirmation" :value="$t('application.auth.confirm_password_label')" />
                            <JetInput
                                id="password_confirmation"
                                v-model="form.password_confirmation"
                                type="password"
                                class="mt-1 block w-full"
                                required
                                autocomplete="new-password"
                            />
                        </div>

                        <div class="flex items-center justify-end mt-4">
                            <JetButton :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                                {{ $t('application.auth.reset_password_button') }}
                            </JetButton>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <JetApplicationFooter :programme="programme" :organisation="organisation" />
</template>
